export type UserFitnessGoals = {
  steps_goal?: number;
  calories_goal?: number;
  sleep_goal?: number;
};

export const FITNESS_GOALS_STORAGE_KEY = "glucera_fitness_goals";

export const loadUserFitnessGoals = (): UserFitnessGoals => {
  try {
    const raw = localStorage.getItem(FITNESS_GOALS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as UserFitnessGoals;
    return {
      ...(parsed.steps_goal != null && parsed.steps_goal > 0
        ? { steps_goal: Math.round(parsed.steps_goal) }
        : {}),
      ...(parsed.calories_goal != null && parsed.calories_goal > 0
        ? { calories_goal: Math.round(parsed.calories_goal) }
        : {}),
      ...(parsed.sleep_goal != null && parsed.sleep_goal > 0
        ? { sleep_goal: parsed.sleep_goal }
        : {}),
    };
  } catch {
    return {};
  }
};

export const saveUserFitnessGoals = (goals: UserFitnessGoals): void => {
  try {
    localStorage.setItem(FITNESS_GOALS_STORAGE_KEY, JSON.stringify(goals));
  } catch {
    // quota / private mode
  }
};

export const parseGoalInput = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n);
};

/** Sleep goal is in hours and may be fractional (e.g. 7.5). */
export const parseSleepGoalInput = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n <= 0 || n > 24) return null;
  return Math.round(n * 10) / 10;
};
